import { UilCreateDashboard } from "@iconscout/react-unicons";
import { Menu } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

import UilEllipsisV from "@iconscout/react-unicons/icons/uil-ellipsis-v";
import propTypes from "prop-types";

function MenuItems({ toggleCollapsed }) {
  const { t } = useTranslation();

  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const { topMenu } = useSelector((state) => {
    return {
      topMenu: state.ChangeLayoutMode.topMenu,
    };
  });

  const path = "/admin";

  const pathName = window.location.pathname;
  const pathArray = pathName.split(path);
  const mainPath = pathArray[1];
  const mainPathSplit = mainPath.split("/");

  const [openKeys, setOpenKeys] = React.useState(
    !topMenu
      ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
      : []
  );

  const onOpenChange = (keys) => {
    setOpenKeys(
      keys[keys.length - 1] !== "recharts"
        ? [keys.length && keys[keys.length - 1]]
        : keys
    );
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) setOpenKeys([]);
  };

  const items = [
    // App menu items
    getItem(
      t("members.members"),
      "members",
      !topMenu && <UilCreateDashboard />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/members`}>
            {t("members.membersList")}
          </NavLink>,
          "members",
          null
        ),
      ]
    ),
    getItem(t("users.users"), "users", !topMenu && <UilCreateDashboard />, [
      getItem(
        <NavLink onClick={toggleCollapsed} to={`${path}/users`}>
          {t("users.usersList")}
        </NavLink>,
        "users",
        null
      ),
    ]),
    getItem(
      t("settings.settings"),
      "settings",
      !topMenu && <UilCreateDashboard />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/activities`}>
            {t("activities.activities")}
          </NavLink>,
          "activities",
          null
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/countries`}>
            {t("countries.countries")}
          </NavLink>,
          "countries",
          null
        ),
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/subscription-packages`}
          >
            {t("subscriptionPackages.subscriptionPackages")}
          </NavLink>,
          "subscriptionPackages",
          null
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/branches`}>
            {t("branches.branches")}
          </NavLink>,
          "branches",
          null
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/qr-codes`}>
            {t("qrcodes.qrcodes")}
          </NavLink>,
          "qrcodes",
          null
        ),
      ]
    ),
    getItem(
      t("reports.reports"),
      "subscriptions",
      !topMenu && <UilCreateDashboard />,
      [
        getItem(
          <NavLink
            onClick={toggleCollapsed}
            to={`${path}/reports/subscriptions`}
          >
            {t("subscriptions.subscriptions")}
          </NavLink>,
          "subscriptions",
          null
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/reports/payments`}>
            {t("payments.payments")}
          </NavLink>,
          "vat",
          null
        ),
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/reports/members`}>
            {t("members.members")}
          </NavLink>,
          "members",
          null
        ),
      ]
    ),
    getItem(
      t("employees.employees"),
      "employees",
      !topMenu && <UilCreateDashboard />,
      [
        getItem(
          <NavLink onClick={toggleCollapsed} to={`${path}/employees`}>
            {t("employees.employeesList")}
          </NavLink>,
          "employees",
          null
        ),
      ]
    ),
  ];

  return (
    <Menu
      onOpenChange={onOpenChange}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? "inline" : "horizontal"}
      // // eslint-disable-next-line no-nested-ternary
      defaultSelectedKeys={
        !topMenu
          ? [
              `${
                mainPathSplit.length === 1
                  ? "home"
                  : mainPathSplit.length === 2
                  ? mainPathSplit[1]
                  : mainPathSplit[2]
              }`,
            ]
          : []
      }
      defaultOpenKeys={
        !topMenu
          ? [`${mainPathSplit.length > 2 ? mainPathSplit[1] : "dashboard"}`]
          : []
      }
      overflowedIndicator={<UilEllipsisV />}
      openKeys={openKeys}
      items={items}
    />
  );
}

MenuItems.propTypes = {
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
